export const ERROR_ICON_COLOR = '#A21C10';

export const formatCountdown = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const outlinedButtonSx = {
  py: 1.5,
  textTransform: 'none',
  borderRadius: 0,
  borderColor: '#070707',
  color: '#070707',
  backgroundColor: 'transparent',
  fontWeight: 500,
  '&:hover': {
    borderColor: '#070707',
    backgroundColor: 'rgba(7, 7, 7, 0.04)',
  },
} as const;

export const solidButtonSx = {
  py: 1.5,
  textTransform: 'none',
  borderRadius: 0,
  backgroundColor: '#070707',
  color: '#fff',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: '#333',
  },
  '&.Mui-disabled': {
    backgroundColor: '#E6E3DF',
    color: '#B1AEAB',
    opacity: 1,
  },
} as const;

export const textButtonSx = {
  py: 1.5,
  textTransform: 'none',
  borderRadius: 0,
  color: '#4D4D4C',
  fontWeight: 500,
  backgroundColor: 'transparent',
  '&:hover': {
    borderRadius: 0,
    color: '#4D4D4C',
    backgroundColor: 'rgba(77, 77, 76, 0.04)',
  },
} as const;

export const linkSx = {
  fontFamily: 'Satoshi, sans-serif',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#4D4D4C',
  textDecorationSkipInk: 'none',
  '&:hover': { color: '#4D4D4C' },
} as const;

export const linkButtonSx = {
  border: 0,
  background: 'none',
  p: 0,
  m: 0,
  cursor: 'pointer',
  textDecoration: 'underline',
  ...linkSx,
  '&:disabled': { cursor: 'default', opacity: 0.6 },
} as const;
